export const GENERAL_SETTINGS = {
  SHOW_FILTER_BY_TAG_SECTION: {
    settingsName: 'show-tag-filtering',
    title: 'Show the section to filter challenges by tags',
  },
  SHOW_CHALLENGE_STATUS_FILTER: {
    settingsName: 'show-status-filtering',
    title: 'Show the challenges grouped by challenge status (Active/Completed/Closed)',
  },
};